@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="modalConfig"
    [visible]="false"
    (confirmed)="onConfirm()"
    (cancelled)="onCancel()"
    (closed)="onCancel()">
  </gtw-confirmation-modal>
</div>
}
